import React from 'react';

interface Props {
    column: number;
}

const HighlightColumn: React.FC<Props> = ({ column }: Props) => (
    <style>
        {`
      .interest-table td.thead-th:nth-child(${column}) {
        text-decoration: underline;
        text-decoration-thickness: 2px;
      }
      .interest-table td:nth-child(${column}) {
        background: var(--table-highlight);
        font-weight: 700;
      }
    `}
    </style>
);

export default HighlightColumn;
